import type { TrackingAttribution } from '~/types/track'

export const TRACKING_ATTRIBUTION_INACTIVITY_TIMEOUT_MS = 2 * 60 * 60 * 1000

export const TRACKING_ATTRIBUTION_QUERY_KEYS = {
  utm_source: 'source',
  utm_medium: 'medium',
  utm_campaign: 'campaign',
  utm_content: 'content',
  utm_term: 'term',
  fbclid: 'metaClickId',
  epik: 'pinterestClickId',
  rdt_cid: 'redditClickId',
  sccid: 'snapchatClickId',
  ttclid: 'tikTokClickId'
} as const satisfies Record<string, keyof TrackingAttribution>

type QueryValue = string | string[] | null | undefined

function firstQueryValue(value: QueryValue): string | undefined {
  const firstValue = Array.isArray(value) ? value[0] : value
  return firstValue || undefined
}

export function getTrackingAttributionFromQuery(query: Record<string, QueryValue>): TrackingAttribution | undefined {
  const attribution: TrackingAttribution = {}

  for (const [queryKey, value] of Object.entries(query)) {
    const attributionKey =
      TRACKING_ATTRIBUTION_QUERY_KEYS[queryKey.toLowerCase() as keyof typeof TRACKING_ATTRIBUTION_QUERY_KEYS]
    const queryValue = firstQueryValue(value)
    if (attributionKey && queryValue) {
      Object.assign(attribution, { [attributionKey]: queryValue })
    }
  }

  if (!Object.keys(attribution).length) return undefined

  attribution.source ||=
    (attribution.pinterestClickId && 'pinterest') ||
    (attribution.metaClickId && 'facebook') ||
    (attribution.tikTokClickId && 'tiktok') ||
    (attribution.snapchatClickId && 'snapchat') ||
    (attribution.redditClickId && 'reddit') ||
    undefined
  const capturedAt = Date.now()
  attribution.capturedAt = capturedAt
  attribution.lastActivityAt = capturedAt

  return attribution
}
